var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import analytics from 'shared-assets/lib/analytics';
import colors from 'shared-assets/lib/colors';
import styled from 'styled-components';
import kfetch from '@kareo/kfetch';
import TelehealthLogo from 'shared-assets/talking-parrot-ui/components/TelehealthLogo';
import LoadingUi from '../components/LoadingUi';
import LayoutCentered from '../components/LayoutCentered';
var PracticeLogo = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: auto;\n  margin: 10px;\n  position: fixed;\n  z-index: 2;\n  @media (max-width: 600px) {\n    width: 15vw;\n    max-width: 40px;\n  }\n\n  @media (min-width: 600px) {\n    width: 15vw;\n    max-width: 60px;\n  }\n\n  @media (min-width: 768px) {\n    width: 10vw;\n    max-width: 60px;\n  }\n\n  @media (min-width: 992px) {\n    width: 10vw;\n    max-width: 80px;\n  }\n\n  @media (min-width: 1200px) {\n    width: 10vw;\n    max-width: 100px;\n  }\n"], ["\n  height: auto;\n  margin: 10px;\n  position: fixed;\n  z-index: 2;\n  @media (max-width: 600px) {\n    width: 15vw;\n    max-width: 40px;\n  }\n\n  @media (min-width: 600px) {\n    width: 15vw;\n    max-width: 60px;\n  }\n\n  @media (min-width: 768px) {\n    width: 10vw;\n    max-width: 60px;\n  }\n\n  @media (min-width: 992px) {\n    width: 10vw;\n    max-width: 80px;\n  }\n\n  @media (min-width: 1200px) {\n    width: 10vw;\n    max-width: 100px;\n  }\n"])));
var buildSearchParams = function (data, isHost) {
    var searchParams = new URLSearchParams({
        audio: 'on',
        background: 'off',
        breakout: 'on',
        callQualityMonitoring: 'on',
        chat: 'on',
        embed: '',
        floatSelf: '',
        iframeSource: 'kareo',
        iosStep: 'off',
        leaveButton: 'on',
        personality: 'off',
        pipButton: 'on',
        recording: 'off',
        screenshare: 'on',
        settingsButton: 'on',
        streaming: 'off',
        subgridLabels: 'on',
        video: 'on',
    });
    if (isHost) {
        searchParams.set('displayName', data.providerName);
        searchParams.set('locking', 'on');
        searchParams.set('timer', 'on');
        searchParams.set('moreButton', 'on');
    }
    if (data.reducedResolution) {
        // flag to reduce screen resolution which may improve audio/connectivity issues.
        searchParams.set('lowData', '');
    }
    return searchParams;
};
var PatientView = /** @class */ (function (_super) {
    __extends(PatientView, _super);
    function PatientView(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            src: '',
            logoUrl: '',
            isLoading: true,
        };
        return _this;
    }
    PatientView.prototype.componentDidMount = function () {
        var _this = this;
        var providerSlug = this.props.match.params.providerSlug;
        try {
            kfetch("/telehealth-ui/api/telehealthurl/slug/" + providerSlug)
                .then(function (data) {
                if (data) {
                    if (providerSlug != data.providerSlugName) {
                        window.location.replace(window.location
                            .toString()
                            .replace(providerSlug, data.providerSlugName));
                    }
                    var wherebyUrl = new URL(data.url);
                    var isHost = wherebyUrl.searchParams.has('roomKey');
                    if (!isHost) {
                        kfetch("/patient-engagement-ui/api/PracticeInfo/" + data.practiceGuid).then(function (practiceData) {
                            return _this.setState({ logoUrl: practiceData.logoUrl });
                        });
                    }
                    var wherebySearchParams_1 = wherebyUrl.searchParams;
                    buildSearchParams(data, isHost).forEach(function (value, key) {
                        wherebySearchParams_1.set(key, value);
                    });
                    analytics.track('Room Joined', __assign({ name: 'Telehealth Room', type: 'static url', providerSlug: providerSlug,
                        isHost: isHost, referrer: document.referrer }, window.location));
                    _this.setState({
                        src: wherebyUrl.toString(),
                        isLoading: false,
                    });
                    return;
                }
                _this.setState({
                    src: '',
                    isLoading: false,
                });
            })
                .catch(function () { return _this.setState({ isLoading: false }); });
        }
        catch (e) {
            this.setState({ isLoading: false });
        }
    };
    PatientView.prototype.render = function () {
        return this.state.isLoading || !this.state.src ? (React.createElement(LayoutCentered, null,
            React.createElement(TelehealthLogo, null),
            this.state.isLoading ? (React.createElement(LoadingUi, { isLoading: true })) : (React.createElement(Card, { style: { width: '100%' } },
                React.createElement(CardContent, null,
                    React.createElement("p", { style: { marginTop: 0, paddingRight: 0, color: colors.error } }, "This link is invalid. Please contact your provider.")))))) : (React.createElement("div", null,
            !!this.state.logoUrl && React.createElement(PracticeLogo, { src: this.state.logoUrl }),
            React.createElement("iframe", { title: "Telehealth", style: {
                    position: 'fixed',
                    border: 'none',
                    width: '100%',
                    height: '100%',
                    background: '#232A2F',
                }, src: this.state.src, allow: "camera; microphone; fullscreen; speaker; display-capture" })));
    };
    return PatientView;
}(React.Component));
export default PatientView;
var templateObject_1;
